import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { GET_USERS } from "./apiRoutes";
import { compactValidateUserParams } from "@/lib/utils";

interface UseValidateUserDataProps {
  params: any;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getUserById = async (params: any) =>
  await axiosAuth.get(`${GET_USERS}/check`, {
    params: compactValidateUserParams(params),
  });

const useValidateUserData = ({
  params,
  queryParams,
}: UseValidateUserDataProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["user", compactValidateUserParams(params)],
    queryFn: () => getUserById(params),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!params && (queryParams?.enabled ?? true),
  });
};

export default useValidateUserData;
